module.exports = __webpack_public_path__ + "img/check_icon.8940bba6.png";